<template>
  <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
    <b-form
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="resetForm"
    >
      <h4>{{ title }}</h4>
      <div class="row">
        <div class="col-12">
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="shelter.name"
                placeholder="Ingresar nombre"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider
            #default="validationContext"
            name="Dirección"
            rules="required"
          >
            <b-form-group
              label="Dirección"
              label-for="address"
            >
              <b-form-input
                id="address"
                v-model="shelter.address"
                placeholder="Ingresar dirección"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
        <div class="col-6">
          <validation-provider
            #default="validationContext"
            name="Teléfono 1"
            rules="required"
          >
            <b-form-group
              label="Teléfono 1"
              label-for="phone_1"
            >
              <b-form-input
                id="phone_1"
                v-model="shelter.phone_1"
                placeholder="Ingresar teléfono 1"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
        <div class="col-6">
          <validation-provider
            #default="validationContext"
            name="Teléfono 2"
          >
            <b-form-group
              label="Teléfono 2"
              label-for="phone_2"
            >
              <b-form-input
                id="phone_2"
                v-model="shelter.phone_2"
                placeholder="Ingresar teléfono 2"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
      </div>
      <div class="text-right">
        <b-button
          type="submit"
          class="mr-1"
          variant="danger"
          :disabled="loading"
          @click="$emit('shelter-form-hide')"
        >
          <span class="text-nowrap">Cancelar</span>
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          :disabled="loading"
        >
          <span class="text-nowrap">Guardar</span>
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import axios from '@/libs/axios';
import { useToast } from "vue-toastification/composition";
import { computed,ref } from '@vue/composition-api';
import {required} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    opSecCrisis: {
      type: Object
    },
    municipalityData: {
      type: Object
    },
    shelter: {
      type: Object
    }
  },
  components: {
    ToastificationContent,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      required
    }
  },
  setup(props, { emit }) {
    const resetData = () => {}

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const loading = ref(false);

    //COMPUTED
    const title = computed(() => (props.shelter.id) ? 'Editar albergue' : 'Nuevo albergue');

    //METHODS
    const onSubmit = async () => {
      loading.value = true;

      const route  = (props.shelter.id) ? `v1/operational-security-crisis/municipality/${props.shelter.id_municipality}/shelters/${props.shelter.id}/edit` :  'v1/operational-security-crisis/municipality/shelters';
      const method = (props.shelter.id) ? 'put' : 'post';

      await axios[method](route, props.shelter)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          emit('refresh-shelters');
          emit('shelter-form-hide');
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            }
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      refFormObserver,
      getValidationState,
      resetForm,

      loading,
      title,

      onSubmit
    }
  }
}
</script>


